import { useContext } from 'react';
import { RadioGroupContext } from '../RadioGroupContext.js';

const useRadio = () => {
    const context = useContext(RadioGroupContext);
    if (!context) {
        throw new Error('useRadio must be used within RadioGroupContext provider');
    }
    return context;
};

export { useRadio };
